import { useCallback, useState } from 'react'

/**
 *
 * @param {boolean} initialState
 * @returns {[boolean, { set: (value: boolean) => void; on: () => void; off: () => void; toggle: () => void}]}
 */
export const useBoolean = (initialState = false) => {
  const [value, setValue] = useState(initialState)

  const set = useCallback((value) => {
    setValue(value)
  }, [setValue])

  const on = useCallback(() => {
    setValue(true)
  }, [])

  const off = useCallback(() => {
    setValue(false)
  }, [])

  const toggle = useCallback(() => {
    setValue(state => !state)
  }, [])

  return [value, { set, on, off, toggle }]
}
